module.exports = __webpack_public_path__ + "img/phone-alt.565acd65.svg";